// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "ecad9bc22fc1eaec0519ac50250a51c146f6dd25/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};